import { CampaignPricing } from '@features/campaigns/shared/types/campaign';

export const mockedPricing: CampaignPricing = {
  impressions: 111,
  bonusImpressions: 123,
  bonusPrice: false,
  availableImpressions: 222,
  estimatedReach: 333,
  estimatedFrequency: 444,
  estimatedReachRange: [1, 2],
  estimatedFrequencyRange: [333, 4444],
  cpm: 555,
  budget: 666,
  targetSize: 777,
};
